import { render, staticRenderFns } from "./selectProductModal.vue?vue&type=template&id=206819e4&"
import script from "./selectProductModal.vue?vue&type=script&lang=ts&"
export * from "./selectProductModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports